var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39092 7.01175L9.38933 6.11175C9.387 4.78627 10.4596 3.70986 11.7851 3.70752L14.1851 3.70329C15.5106 3.70095 16.587 4.77357 16.5893 6.09905L16.5909 6.99905L19.5909 6.99376C20.088 6.99289 20.4916 7.39512 20.4925 7.89218C20.4934 8.38923 20.0911 8.79288 19.5941 8.79376L18.9941 8.79482L19.0105 18.0948C19.0128 19.4203 17.9402 20.4967 16.6147 20.499L9.41472 20.5117C8.08924 20.5141 7.01283 19.4414 7.01049 18.116L6.9941 8.81598L6.3941 8.81703C5.89704 8.81791 5.49339 8.41568 5.49251 7.91862C5.49164 7.42157 5.89387 7.01791 6.39092 7.01704L9.39092 7.01175ZM11.1904 6.70857L14.7904 6.70223L14.7893 6.10223C14.7887 5.77086 14.5196 5.5027 14.1883 5.50329L11.7883 5.50752C11.4569 5.5081 11.1887 5.7772 11.1893 6.10857L11.1904 6.70857ZM8.79409 8.8128L17.1941 8.79799L17.2105 18.098C17.2111 18.4293 16.9429 18.6984 16.6115 18.699L9.41155 18.7117C9.08018 18.7123 8.81107 18.4442 8.81049 18.1128L8.79409 8.8128Z",
    fill: "#858E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconn);
export default __webpack_public_path__ + "static/media/DeleteIconn.df7417c2b6d792290312bd91c149b731.svg";
export { ForwardRef as ReactComponent };